module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Reprise du réapprovisionnement automatique',
        mainHeader: 'Vous êtes prêt',
        subHeader: 'Votre réapprovisionnement automatique a repris et les livraisons recommenceront le ',
        item: 'ARTICLE',
        qty: 'Qté',
        notRated: 'Aucune note',
        oneReview: 'Un commentaire',
        yearlySavings: 'économies annuelles',
        done: 'Terminé'
    };

    return resources[label];
};
